import { useEffect, useState } from "react";
import "./pay.scss";
import LoadError from "../components/error";
import { updateUserPaidStatus } from "../components/utils";
import { useNavigate, useLocation } from "react-router-dom";
import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentElement } from "@stripe/react-stripe-js";
import { BrandButton, BrandButtonWhite } from "../components/form/buttons";
import { homeUrl } from "../components/utils";
import { Alert, Snackbar } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";

interface PageProps {
  paymentIntentId?: string;
  clientSecret?: any;
  token: string;
  userid: number;
  chargeAmount: number;
  userData: any;
  username: string;
}

interface CheckoutProps {
  token: string;
  userid: number;
  userData: any;
  username: string;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

const CheckoutForm = ({ token, userid, userData, username }: CheckoutProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [snackError, setSnackError] = useState(false);
  const vertical = "bottom";
  const horizontal = "center";

  const submitPayment = async () => {
    // setLoading(true);
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setLoading(true);

    const { error } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${homeUrl}#/register-confirm`,
      },
      redirect: "if_required",
    });

    if (error) {
      setErrorMessage(error.message as any);
      setLoading(false);
    } else {
      const paidResp = await updateUserPaidStatus(token, userid);
      if (paidResp) {
        navigate("/register-confirm", {
          replace: true,
        });
      } else {
        setSnackError(true);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const onEnter = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        submitPayment();
      }
    };
    document.addEventListener("keydown", onEnter);
    return () => {
      document.removeEventListener("keydown", onEnter);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe, elements]);

  return (
    <div className="formHolder">
      <PaymentElement />
      <hr />
      <div className="btn-holder">
        {stripe && !loading ? (
          <div className="buttonOptions">
            <BrandButtonWhite
              onClick={() =>
                navigate("/register-coupon", {
                  state: {
                    token,
                    userid,
                    userData,
                    username,
                  },
                })
              }
            >
              <FontAwesomeIcon icon={faChevronLeft} /> Go Back
            </BrandButtonWhite>
            <BrandButton onClick={submitPayment} disabled={!stripe}>
              {" "}
              Submit Payment
            </BrandButton>
          </div>
        ) : (
          "loading..."
        )}
        {loading && <FontAwesomeIcon icon={faSpinner} />}
      </div>
      {errorMessage && <div className="errorMsg">{errorMessage}</div>}

      <Snackbar
        open={snackError}
        autoHideDuration={4000}
        onClose={() => setSnackError(false)}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert severity="error">
          Sorry, There was a problem processing your payment.
        </Alert>
      </Snackbar>
    </div>
  );
};

const RegisterPay = () => {
  const location = useLocation();
  const {
    paymentIntentId,
    clientSecret,
    token,
    userid,
    chargeAmount,
    userData,
    username,
  } = (location.state as PageProps) || {};
  const navigate = useNavigate();

  const options = {
    // passing the client secret obtained in step 3
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  if (!paymentIntentId && !clientSecret) return <LoadError />;

  return (
    <div>
      <div className="payPageHeaderNavHolder">
        <BrandButtonWhite
          onClick={() =>
            navigate("/register-coupon", {
              state: {
                token,
                userid,
                userData,
                username,
              },
            })
          }
        >
          <FontAwesomeIcon icon={faChevronLeft} /> Go Back
        </BrandButtonWhite>
      </div>

      <div className="payPage">
        <div className="headline">
          <h1>Payment</h1>
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: `Please use the form below to pay for your exam.`,
            }}
          />
        </div>
        <h2>
          You will be charged <span>${chargeAmount}.00</span>
        </h2>
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm
            token={token}
            userid={userid}
            userData={userData}
            username={username}
          />
        </Elements>
      </div>
    </div>
  );
};

export default RegisterPay;
